import { NgModule, Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'content',
    templateUrl: 'content.template.html',
    styleUrls: ['content.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentRow {
    @Input() item: any;
    @Input() direction: string;
    

    ngOnInit() {
        //console.info(this.item);
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/content-list/content/content.component.ts